import { render, staticRenderFns } from "./GCropper.vue?vue&type=template&id=5e6e5521&"
import script from "./GCropper.vue?vue&type=script&lang=ts&"
export * from "./GCropper.vue?vue&type=script&lang=ts&"
import style0 from "./GCropper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports